export const EnforceShiftsOverviewV2 = 'enforce-shifts-overview-v2';
